import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';

import reportWebVitals from './reportWebVitals';
import { TemaProvider } from './styles/TemaProvider';
import Routes from './routes';

import Toastify from './template/Toastify';

// O provedor de tema fica na raiz, e não dentro do shell: o Login e a tela de
// carregamento ficam fora do shell e também precisam do tema escolhido.
ReactDOM.render(
  <React.StrictMode>
    <TemaProvider>
      <Toastify />
      <Routes />
    </TemaProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.register();
reportWebVitals();
